import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
    enableProdMode();
}

/**
 * First-touch attribution capture: digitalsignage.com decorates its
 * /signstudio/getstarted links with utm/referrer params (_js/attribution.js).
 * Grab them here, before the Angular router strips the query string;
 * user.service reportAccountAttribution() forwards them to mars
 * (/dwAccountAttribution) once an account is actually created.
 */
try {
    const qs = new URLSearchParams(window.location.search);
    if (qs.get('utm_source') || qs.get('dsref')) {
        sessionStorage.setItem('ds_attrib', JSON.stringify({
            utm_source: qs.get('utm_source') || '',
            utm_medium: qs.get('utm_medium') || '',
            utm_campaign: qs.get('utm_campaign') || '',
            dsref: qs.get('dsref') || '',
            dsland: qs.get('dsland') || '',
            dsdate: qs.get('dsdate') || '',
            // 2026-09-26: ad-level tags + the ChatGPT Ads click reference (oppref) for server-side conversions
            utm_term: qs.get('utm_term') || '',
            utm_content: qs.get('utm_content') || '',
            oppref: qs.get('oppref') || ''
        }));
    }
} catch (e) {
    // attribution must never block bootstrap
}

platformBrowserDynamic().bootstrapModule(AppModule, {
    ngZoneEventCoalescing: false,
    ngZoneRunCoalescing: false
})
    .catch(err => {
        console.error('====== BOOTSTRAP ERROR ======');
        console.error('Error Type:', err.name);
        console.error('Error Message:', err.message);
        console.error('Full Error:', err);
        console.error('Stack Trace:', err.stack);
        console.error('============================');
    });

/**
 * Enable debugging of tick cycle times:
 * enable following line and in dev console run command: ng.profiler.timeChangeDetection()
 * notes: https://itnext.io/heres-how-to-find-the-change-detection-bottle-necks-in-your-angular-application-333a71758477
 *
 * import {enableDebugTools} from "@angular/platform-browser";
 * import {ApplicationRef, enableProdMode} from '@angular/core';
 * platformBrowserDynamic().bootstrapModule(AppModule).then(module => enableDebugTools(module.injector.get(ApplicationRef).components[0])).catch(err => console.error(err));
 *
 **/

